import { createFileRoute } from '@tanstack/react-router'

import Websites from '@/features/Admin/Websites'

export const Route = createFileRoute('/_authenticated/admin/websites')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Websites />
}
